exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".formLine {\n  display: -ms-flexbox;\n  display: flex;\n  padding: 8px 0px;\n  margin-left: 2px;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.uploadLabel {\n  padding: 8px 0px;\n  margin-left: 2px;\n}\n.download {\n  display: none;\n}\n.ui-dialog {\n  overflow: auto;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/action-plan/action-plan-modal/action-plan-modal.component.css
// module id = ../../../../../src/app/action-plan/action-plan-modal/action-plan-modal.component.css
// module chunks = main